import { usePromptEditorContext } from "@/context/PromptEditorContext";
import { AGENT_MESSAGE_ROLES, CHAT_MESSAGE_ROLES, ChatMessageRole } from "@/services/promptEditor.service";
import { ContextMenu } from "@components/library/ContextMenu";
import { MessageRoleTag } from "@components/PromptEditor/MessageRoleTag";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { capitalize } from "lodash";
import { useState } from "react";

interface Props {
  role: ChatMessageRole;
  setRole?: (role: ChatMessageRole) => void;
  toolRoleEnabled?: boolean;
}

const MessageRoleDropdown = ({ role, setRole, toolRoleEnabled }: Props) => {
  const [open, setOpen] = useState(false);
  const { isAgent } = usePromptEditorContext();
  if (!setRole) return <MessageRoleTag>{role}</MessageRoleTag>;

  const ROLES = isAgent ? AGENT_MESSAGE_ROLES : CHAT_MESSAGE_ROLES;

  return (
    <DropdownMenu.Root open={open} onOpenChange={setOpen}>
      <DropdownMenu.Trigger asChild>
        <MessageRoleTag active={open} interactive={!!setRole}>
          {role}
        </MessageRoleTag>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <ContextMenu.Items
          isDropdownMenu
          align="start"
          sideOffset={4}
          className="z-50 w-[82px] bg-white capitalize text-text-base-1"
        >
          {ROLES.map((r: ChatMessageRole) => {
            const active = r === role;
            return (
              <ContextMenu.Item
                key={r}
                withinDropdownMenu
                disabled={r === "tool" && !toolRoleEnabled}
                onClick={setRole ? () => setRole(r) : undefined}
                className={active ? "font-bold" : "font-medium"}
              >
                {capitalize(r)}
              </ContextMenu.Item>
            );
          })}
        </ContextMenu.Items>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
};

export default MessageRoleDropdown;
